// @ts-nocheck
/* eslint-disable */
import type { CalendarDate } from '@internationalized/date';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string in YYYY-MM-DD format */
  CalendarDate: { input: CalendarDate; output: CalendarDate; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

/** Which field a household matched an account search on */
export enum AccountMatchField {
  FamilyName = 'FAMILY_NAME',
  UserEmail = 'USER_EMAIL',
  UserName = 'USER_NAME'
}

export type AdminAccountSearchResult = {
  __typename?: 'AdminAccountSearchResult';
  createdAt: Scalars['DateTimeISO']['output'];
  familyId: Scalars['ID']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  matchedOn: AccountMatchField;
  memberCount: Scalars['Int']['output'];
  primaryEmail?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
};

export type AdminBankConnection = {
  __typename?: 'AdminBankConnection';
  accounts: Array<AdminFinancialAccount>;
  consentedProducts?: Maybe<Array<Scalars['String']['output']>>;
  historicalSyncComplete: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  institutionName: Scalars['String']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  linkedAt: Scalars['DateTimeISO']['output'];
  linkedByName: Scalars['String']['output'];
  linkedByUserId: Scalars['ID']['output'];
  needsReconnection: Scalars['Boolean']['output'];
  neverSynced: Scalars['Boolean']['output'];
  plaidItemId: Scalars['String']['output'];
  stale: Scalars['Boolean']['output'];
};

export type AdminBilling = {
  __typename?: 'AdminBilling';
  paymentMethods: Array<AdminPaymentMethod>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<AdminSubscription>;
};

export type AdminCreateBillInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amountDue: Scalars['Float']['input'];
  billSubmissionId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['CalendarDate']['input'];
  familyId: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isAutopay?: InputMaybe<Scalars['Boolean']['input']>;
  lateFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  lateFeeDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  minAmountDue?: InputMaybe<Scalars['Float']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  paymentUrl?: InputMaybe<Scalars['String']['input']>;
  previousAccountBalance?: InputMaybe<Scalars['Float']['input']>;
  providerEmail?: InputMaybe<Scalars['String']['input']>;
  providerName: Scalars['String']['input'];
  providerPhone?: InputMaybe<Scalars['String']['input']>;
  recurringTransactionId?: InputMaybe<Scalars['ID']['input']>;
  serviceEndDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  serviceStartDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  source: BillSource;
  statementDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  userId: Scalars['ID']['input'];
};

export type AdminDependent = {
  __typename?: 'AdminDependent';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  linkedUserId?: Maybe<Scalars['ID']['output']>;
  partnerships: Array<AdminDependentPartnership>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  relationships: Array<AdminDependentRelationship>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type AdminDependentPartnership = {
  __typename?: 'AdminDependentPartnership';
  liveTogether?: Maybe<Scalars['Boolean']['output']>;
  partnerDependentId: Scalars['ID']['output'];
  partnerName: Scalars['String']['output'];
  relationship: PartnerRelationship;
  relationshipOther?: Maybe<Scalars['String']['output']>;
};

export type AdminDependentRelationship = {
  __typename?: 'AdminDependentRelationship';
  caregiverName: Scalars['String']['output'];
  caregiverUserId: Scalars['ID']['output'];
  isInLaw: Scalars['Boolean']['output'];
  isStep: Scalars['Boolean']['output'];
  livesWithCaregiver?: Maybe<Scalars['Boolean']['output']>;
  relationship: CaregiverRelationship;
  relationshipOther?: Maybe<Scalars['String']['output']>;
};

export type AdminFamilyAccount = {
  __typename?: 'AdminFamilyAccount';
  bankConnections: Array<AdminBankConnection>;
  billing: AdminBilling;
  createdAt: Scalars['DateTimeISO']['output'];
  dependents: Array<AdminDependent>;
  id: Scalars['ID']['output'];
  inboundEmailAddress?: Maybe<Scalars['String']['output']>;
  linkedUsers: Array<AdminLinkedUser>;
  memberCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  openWorkItems: AdminOpenWorkItems;
  possessions: AdminPossessions;
};

export type AdminFinancialAccount = {
  __typename?: 'AdminFinancialAccount';
  hiddenAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subtype?: Maybe<FinancialAccountSubtype>;
  type: FinancialAccountPrimaryType;
};

export type AdminFinancialAccountDetail = {
  __typename?: 'AdminFinancialAccountDetail';
  availableBalance?: Maybe<Scalars['Float']['output']>;
  balanceAsOf?: Maybe<Scalars['DateTimeISO']['output']>;
  balanceRawJson?: Maybe<Scalars['JSONObject']['output']>;
  bankConnectionId: Scalars['ID']['output'];
  canonicalName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  creditLimit?: Maybe<Scalars['Float']['output']>;
  creditUtilizationThreshold?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  disableThreshold?: Maybe<Scalars['Boolean']['output']>;
  externalId: Scalars['String']['output'];
  financialAccountId: Scalars['ID']['output'];
  investmentAudit?: Maybe<AdminInvestmentAccountAudit>;
  lowBalanceThreshold?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  version: Scalars['Int']['output'];
};

export type AdminImpersonateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminImpersonateUserOutput = {
  __typename?: 'AdminImpersonateUserOutput';
  redirectUrl: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/** A channel a household member has written to the assistant on */
export enum AdminInboundChannel {
  App = 'APP',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type AdminInvestmentAccountAudit = {
  __typename?: 'AdminInvestmentAccountAudit';
  accountName: Scalars['String']['output'];
  balanceAsOf?: Maybe<Scalars['DateTimeISO']['output']>;
  balanceGap?: Maybe<Scalars['Float']['output']>;
  bankConnectionId: Scalars['ID']['output'];
  cashEquivalentValue?: Maybe<Scalars['Float']['output']>;
  consentedProducts?: Maybe<Array<Scalars['String']['output']>>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  financialAccountId: Scalars['ID']['output'];
  holdingsValue?: Maybe<Scalars['Float']['output']>;
  institutionName: Scalars['String']['output'];
  investmentsConsented: Scalars['Boolean']['output'];
  latestSnapshotAt?: Maybe<Scalars['DateTimeISO']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  positionCount: Scalars['Int']['output'];
  positions: Array<AdminInvestmentHoldingPosition>;
  positionsMissingCostBasis: Scalars['Int']['output'];
  positionsMissingPrice: Scalars['Int']['output'];
  positionsQuantityChangedWithoutPriceChange: Scalars['Int']['output'];
  positionsWithUnidentifiedSecurity: Scalars['Int']['output'];
  previousSnapshotAt?: Maybe<Scalars['DateTimeISO']['output']>;
  relinkCandidate: Scalars['Boolean']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
};

export type AdminInvestmentHoldingPosition = {
  __typename?: 'AdminInvestmentHoldingPosition';
  closePrice?: Maybe<Scalars['Float']['output']>;
  closePriceAsOf?: Maybe<Scalars['String']['output']>;
  costBasis?: Maybe<Scalars['Float']['output']>;
  cusip?: Maybe<Scalars['String']['output']>;
  externalSecurityId?: Maybe<Scalars['String']['output']>;
  holdingRawJson?: Maybe<Scalars['JSONObject']['output']>;
  institutionPrice?: Maybe<Scalars['Float']['output']>;
  institutionPriceAsOf?: Maybe<Scalars['String']['output']>;
  institutionValue?: Maybe<Scalars['Float']['output']>;
  isCashEquivalent?: Maybe<Scalars['Boolean']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  isoCurrencyCode?: Maybe<Scalars['String']['output']>;
  missingCostBasis: Scalars['Boolean']['output'];
  missingPrice: Scalars['Boolean']['output'];
  previousInstitutionPrice?: Maybe<Scalars['Float']['output']>;
  previousQuantity?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  quantityChangedWithoutPriceChange: Scalars['Boolean']['output'];
  securityId: Scalars['ID']['output'];
  securityName?: Maybe<Scalars['String']['output']>;
  securityRawJson?: Maybe<Scalars['JSONObject']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  sedol?: Maybe<Scalars['String']['output']>;
  tickerSymbol?: Maybe<Scalars['String']['output']>;
  unidentifiedSecurity: Scalars['Boolean']['output'];
  unofficialCurrencyCode?: Maybe<Scalars['String']['output']>;
};

export type AdminInvestmentHoldingsSyncResult = {
  __typename?: 'AdminInvestmentHoldingsSyncResult';
  accountsSynced?: Maybe<Scalars['Int']['output']>;
  bankConnectionId: Scalars['ID']['output'];
  consentedProducts?: Maybe<Array<Scalars['String']['output']>>;
  holdingsRecorded?: Maybe<Scalars['Int']['output']>;
  lastHoldingsSyncAt?: Maybe<Scalars['DateTimeISO']['output']>;
  outcome: InvestmentHoldingsSyncOutcome;
  providerErrorCode?: Maybe<Scalars['String']['output']>;
};

export type AdminLastInboundMessage = {
  __typename?: 'AdminLastInboundMessage';
  channel: AdminInboundChannel;
  sentAt: Scalars['DateTimeISO']['output'];
};

export type AdminLinkedUser = {
  __typename?: 'AdminLinkedUser';
  createdAt: Scalars['DateTimeISO']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  familyRole: FamilyRole;
  firstName?: Maybe<Scalars['String']['output']>;
  googleAuthLinked: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastInboundMessages: Array<AdminLastInboundMessage>;
  lastLoginAt?: Maybe<Scalars['DateTimeISO']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  outreachActiveHoursEnd: Scalars['String']['output'];
  outreachActiveHoursStart: Scalars['String']['output'];
  outreachChannels: Array<AdminOutreachChannel>;
  outreachDailyCap: Scalars['Int']['output'];
  outreachHistory: AdminOutreachHistory;
  outreachTimezone: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  recentNotifications: Array<AdminOutreachNotification>;
  smsConsentState?: Maybe<SmsConsentState>;
  status: UserStatus;
};

export type AdminMandate = {
  __typename?: 'AdminMandate';
  acceptedAt: Scalars['DateTimeISO']['output'];
  acceptedByName: Scalars['String']['output'];
  acceptedByUserId: Scalars['ID']['output'];
  amountDisplay: Scalars['String']['output'];
  firstChargeDisplay?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identityMatchResult?: Maybe<IdentityMatchResult>;
  ip?: Maybe<Scalars['String']['output']>;
  mandateTextVersion: Scalars['String']['output'];
  revocationChannel?: Maybe<MandateRevocationChannel>;
  revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  thirdPartyAck: Scalars['Boolean']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AdminOpenWorkItem = {
  __typename?: 'AdminOpenWorkItem';
  assigneeName?: Maybe<Scalars['String']['output']>;
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  caregiverOnly: Scalars['Boolean']['output'];
  category?: Maybe<WorkItemUserCategory>;
  createdAt: Scalars['DateTimeISO']['output'];
  dueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  nudgeDismissedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  nudgeDispatchedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  title: Scalars['String']['output'];
};

export type AdminOpenWorkItems = {
  __typename?: 'AdminOpenWorkItems';
  items: Array<AdminOpenWorkItem>;
  totalReturned: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

/** A channel the assistant can reach a household member out of band on */
export enum AdminOutreachChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type AdminOutreachHistory = {
  __typename?: 'AdminOutreachHistory';
  emailDelivered: Scalars['Int']['output'];
  smsDelivered: Scalars['Int']['output'];
  windowDays: Scalars['Int']['output'];
};

export type AdminOutreachNotification = {
  __typename?: 'AdminOutreachNotification';
  body?: Maybe<Scalars['String']['output']>;
  cardAsDelivered: Scalars['Boolean']['output'];
  caregiverOnly: Scalars['Boolean']['output'];
  category?: Maybe<WorkItemUserCategory>;
  channel: AdminOutreachChannel;
  deliveredAt: Scalars['DateTimeISO']['output'];
  outreachId: Scalars['ID']['output'];
  threadId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workItemId: Scalars['ID']['output'];
};

export type AdminPaymentMethod = {
  __typename?: 'AdminPaymentMethod';
  createdAt: Scalars['DateTimeISO']['output'];
  financialAccountId?: Maybe<Scalars['ID']['output']>;
  financialAccountName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutionName?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  mandates: Array<AdminMandate>;
  mask?: Maybe<Scalars['String']['output']>;
  status: PaymentMethodStatus;
  stripePaymentMethodId: Scalars['String']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdminPossessionOwner = {
  __typename?: 'AdminPossessionOwner';
  dependentId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminPossessions = {
  __typename?: 'AdminPossessions';
  residences: Array<AdminResidence>;
  vehicles: Array<AdminVehicle>;
};

export type AdminResidence = {
  __typename?: 'AdminResidence';
  address?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  owner?: Maybe<AdminPossessionOwner>;
  ownership?: Maybe<HousingOwnership>;
  ownershipOther?: Maybe<Scalars['String']['output']>;
  residenceType: ResidenceType;
  residenceTypeOther?: Maybe<Scalars['String']['output']>;
};

export enum AdminSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AdminStartAssistantBenchmarkInput = {
  baseSha: Scalars['String']['input'];
  headSha: Scalars['String']['input'];
  scenarioGlob?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSubscription = {
  __typename?: 'AdminSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  instrumentSwitchClaimedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  interval: SubscriptionInterval;
  pendingInterval?: Maybe<SubscriptionInterval>;
  pendingIntervalAt?: Maybe<Scalars['DateTimeISO']['output']>;
  priceId: Scalars['String']['output'];
  status: SubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdminVehicle = {
  __typename?: 'AdminVehicle';
  id: Scalars['ID']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<AdminPossessionOwner>;
  ownership: VehicleOwnership;
  ownershipOther?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type AdminWorkItem = {
  __typename?: 'AdminWorkItem';
  archivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  bankConnectionId?: Maybe<Scalars['ID']['output']>;
  billIds: Array<Scalars['ID']['output']>;
  billSubmissionId?: Maybe<Scalars['ID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  caregiverOnly: Scalars['Boolean']['output'];
  category?: Maybe<WorkItemUserCategory>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdByEmail?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTimeISO']['output']>;
  familyId: Scalars['ID']['output'];
  familyMemberCount: Scalars['Int']['output'];
  financialAccountId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  journal?: Maybe<Scalars['String']['output']>;
  merchantIds: Array<Scalars['ID']['output']>;
  primaryUserEmail?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  recurringTransactionId?: Maybe<Scalars['ID']['output']>;
  sourceThreadId?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transactionIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  workItemScheduleId?: Maybe<Scalars['ID']['output']>;
};

/** Whether the assistant holds a work item or a person owes it */
export enum AdminWorkItemAssigneeFilter {
  Assistant = 'ASSISTANT',
  Household = 'HOUSEHOLD'
}

export type AdminWorkItemJournalEntry = {
  __typename?: 'AdminWorkItemJournalEntry';
  authorEmail?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  caregiverOnly: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  sourceThreadId?: Maybe<Scalars['ID']['output']>;
};

export type AdminWorkItemJournalEntryListing = {
  __typename?: 'AdminWorkItemJournalEntryListing';
  entries: Array<AdminWorkItemJournalEntry>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type AdminWorkItemListing = {
  __typename?: 'AdminWorkItemListing';
  hasMore: Scalars['Boolean']['output'];
  nextBeforeId?: Maybe<Scalars['ID']['output']>;
  workItems: Array<AdminWorkItem>;
};

export type AdminWorkItemSchedule = {
  __typename?: 'AdminWorkItemSchedule';
  archivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdByEmail?: Maybe<Scalars['String']['output']>;
  cron: Scalars['String']['output'];
  defaultKey?: Maybe<Scalars['String']['output']>;
  emittedCount: Scalars['Int']['output'];
  familyId: Scalars['ID']['output'];
  familyMemberCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instruction: Scalars['String']['output'];
  lastRunAt?: Maybe<Scalars['DateTimeISO']['output']>;
  nextRunAt: Scalars['DateTimeISO']['output'];
  primaryUserEmail?: Maybe<Scalars['String']['output']>;
  sourceThreadId?: Maybe<Scalars['ID']['output']>;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdminWorkItemScheduleListing = {
  __typename?: 'AdminWorkItemScheduleListing';
  hasMore: Scalars['Boolean']['output'];
  nextBeforeId?: Maybe<Scalars['ID']['output']>;
  schedules: Array<AdminWorkItemSchedule>;
};

/** Which date column orders a work item listing */
export enum AdminWorkItemSortField {
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE',
  UpdatedAt = 'UPDATED_AT'
}

export type AlphaAllowListEntry = {
  __typename?: 'AlphaAllowListEntry';
  addedByUserEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  normalizedEmail: Scalars['String']['output'];
};

export type AnnouncePreReleaseResult = {
  __typename?: 'AnnouncePreReleaseResult';
  draftTag: Scalars['String']['output'];
  draftUrl: Scalars['String']['output'];
  slackMessageUrl?: Maybe<Scalars['String']['output']>;
};

export type AssistantBenchmarkRun = {
  __typename?: 'AssistantBenchmarkRun';
  baseSha: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  correlationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  githubRunUrl?: Maybe<Scalars['String']['output']>;
  headSha: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  scenarioGlob?: Maybe<Scalars['String']['output']>;
  status: AssistantBenchmarkRunStatus;
  triggeredByUserId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  verdict?: Maybe<Scalars['JSONObject']['output']>;
};

/** Lifecycle + outcome of a two-commit assistant benchmark run. */
export enum AssistantBenchmarkRunStatus {
  Errored = 'ERRORED',
  Failed = 'FAILED',
  Inconclusive = 'INCONCLUSIVE',
  Passed = 'PASSED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type AssistantCompactionMetadata = {
  __typename?: 'AssistantCompactionMetadata';
  droppedCount: Scalars['Int']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  inputTokens: Scalars['Int']['output'];
  keptCount: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  summarizedCount: Scalars['Int']['output'];
};

export type AssistantFeedback = {
  __typename?: 'AssistantFeedback';
  body: Scalars['String']['output'];
  commentCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  familyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: AssistantFeedbackStatus;
  submitterEmail?: Maybe<Scalars['String']['output']>;
  threadId: Scalars['ID']['output'];
  turnId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type AssistantFeedbackComment = {
  __typename?: 'AssistantFeedbackComment';
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorUserId: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  feedbackId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  transition?: Maybe<AssistantFeedbackCommentTransition>;
};

/** On a comment, the status change it accompanied (RESOLVED / REOPENED); null for a plain comment. */
export enum AssistantFeedbackCommentTransition {
  Reopened = 'REOPENED',
  Resolved = 'RESOLVED'
}

export type AssistantFeedbackListing = {
  __typename?: 'AssistantFeedbackListing';
  feedback: Array<AssistantFeedback>;
  hasMore: Scalars['Boolean']['output'];
  nextBefore?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Triage state of an assistant feedback row: OPEN (needs attention) or RESOLVED (handled). */
export enum AssistantFeedbackStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type AssistantMemory = {
  __typename?: 'AssistantMemory';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  effectiveImportance: Scalars['Float']['output'];
  familyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  importance: Scalars['Int']['output'];
  scope: AssistantMemoryScope;
  source: Scalars['String']['output'];
  sourceThreadId?: Maybe<Scalars['ID']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AssistantMemoryExtractionMetadata = {
  __typename?: 'AssistantMemoryExtractionMetadata';
  capExceeded?: Maybe<Scalars['Boolean']['output']>;
  duplicateSkipCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  existingMemoryCount?: Maybe<Scalars['Int']['output']>;
  existingTruncated?: Maybe<Scalars['Boolean']['output']>;
  extractedCount: Scalars['Int']['output'];
  familyCount: Scalars['Int']['output'];
  forgottenCount?: Maybe<Scalars['Int']['output']>;
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  prefCount: Scalars['Int']['output'];
  staleSkipCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated The extractor no longer mints deferred-work rows; historical value, 0 on new runs. */
  todoCount: Scalars['Int']['output'];
  updatedCount?: Maybe<Scalars['Int']['output']>;
  userCount: Scalars['Int']['output'];
};

export type AssistantMemoryJournalEntry = {
  __typename?: 'AssistantMemoryJournalEntry';
  actor: Scalars['String']['output'];
  actorUserId?: Maybe<Scalars['ID']['output']>;
  after?: Maybe<AssistantMemoryJournalImage>;
  before?: Maybe<AssistantMemoryJournalImage>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  memoryId: Scalars['ID']['output'];
  operation: Scalars['String']['output'];
  rationale?: Maybe<Scalars['String']['output']>;
  scope: AssistantMemoryScope;
  sourceThreadId?: Maybe<Scalars['ID']['output']>;
};

export type AssistantMemoryJournalImage = {
  __typename?: 'AssistantMemoryJournalImage';
  body: Scalars['String']['output'];
  importance: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type AssistantMemoryJournalListing = {
  __typename?: 'AssistantMemoryJournalListing';
  entries: Array<AssistantMemoryJournalEntry>;
  hasMore: Scalars['Boolean']['output'];
};

export type AssistantMemoryListing = {
  __typename?: 'AssistantMemoryListing';
  hasMore: Scalars['Boolean']['output'];
  includesFamilyScope: Scalars['Boolean']['output'];
  memories: Array<AssistantMemory>;
};

/** Which underlying memory table a memory row came from. */
export enum AssistantMemoryScope {
  Family = 'FAMILY',
  User = 'USER'
}

export type AssistantThread = {
  __typename?: 'AssistantThread';
  channel: Scalars['String']['output'];
  compactedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  compactionMetadata?: Maybe<AssistantCompactionMetadata>;
  compactionModelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  externalThreadKey?: Maybe<Scalars['String']['output']>;
  familyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastActivityAt: Scalars['DateTimeISO']['output'];
  latestDirective?: Maybe<Scalars['String']['output']>;
  memoryExtractedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  memoryExtractionMetadata?: Maybe<AssistantMemoryExtractionMetadata>;
  memoryExtractionModelId?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  priorThreadId?: Maybe<Scalars['ID']['output']>;
  searchMatch?: Maybe<AssistantThreadSearchMatch>;
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  usage?: Maybe<AssistantThreadUsage>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AssistantThreadDetail = {
  __typename?: 'AssistantThreadDetail';
  hasMore: Scalars['Boolean']['output'];
  messages: Array<AssistantThreadMessage>;
  nextAfterSequence?: Maybe<Scalars['Int']['output']>;
  thread: AssistantThread;
};

export type AssistantThreadListing = {
  __typename?: 'AssistantThreadListing';
  hasMore: Scalars['Boolean']['output'];
  threads: Array<AssistantThread>;
};

export type AssistantThreadMessage = {
  __typename?: 'AssistantThreadMessage';
  completedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  firstTextAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  latencyMs?: Maybe<Scalars['Int']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  payload: Scalars['JSONObject']['output'];
  role: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  thinkingMs?: Maybe<Scalars['Int']['output']>;
  threadId: Scalars['ID']['output'];
  ttftMs?: Maybe<Scalars['Int']['output']>;
  turnId: Scalars['ID']['output'];
};

export type AssistantThreadSearchMatch = {
  __typename?: 'AssistantThreadSearchMatch';
  matchCount: Scalars['Int']['output'];
  turnId: Scalars['ID']['output'];
};

export type AssistantThreadUsage = {
  __typename?: 'AssistantThreadUsage';
  cacheReadTokens: Scalars['Int']['output'];
  cacheWriteTokens: Scalars['Int']['output'];
  costUsd: Scalars['Float']['output'];
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  reasoningTokens: Scalars['Int']['output'];
  roundCount: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type Bank = IEntity & INode & {
  __typename?: 'Bank';
  id: Scalars['ID']['output'];
  logoBase64Encoding?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
};

export type BankConnection = INode & {
  __typename?: 'BankConnection';
  accounts: Array<FinancialAccount>;
  bank: Bank;
  externalId: Scalars['String']['output'];
  hasPotentialSyncIssue: Scalars['Boolean']['output'];
  historicalSyncComplete: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
};

export type BankConnectionHealthStatus = {
  __typename?: 'BankConnectionHealthStatus';
  bankConnectionId: Scalars['String']['output'];
  consentedProducts?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  lastHoldingsSyncAt?: Maybe<Scalars['DateTimeISO']['output']>;
  neverSynced: Scalars['Boolean']['output'];
  plaidJSON?: Maybe<Scalars['JSONObject']['output']>;
  stale: Scalars['Boolean']['output'];
};

export type Bill = INode & {
  __typename?: 'Bill';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue: Scalars['String']['output'];
  amountPaid: Scalars['String']['output'];
  amountRemaining: Scalars['String']['output'];
  billSubmission?: Maybe<BillSubmission>;
  createdAt: Scalars['DateTimeISO']['output'];
  currencyCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate: Scalars['CalendarDate']['output'];
  financialAccount?: Maybe<FinancialAccount>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutopay?: Maybe<Scalars['Boolean']['output']>;
  lateFeeAmount?: Maybe<Scalars['String']['output']>;
  lateFeeDate?: Maybe<Scalars['CalendarDate']['output']>;
  merchant?: Maybe<Merchant>;
  minAmountDue?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  previousAccountBalance?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerPhone?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  recurringTransaction?: Maybe<RecurringTransaction>;
  senderIdentifier?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['CalendarDate']['output']>;
  serviceStartDate?: Maybe<Scalars['CalendarDate']['output']>;
  source: BillSource;
  statementDate?: Maybe<Scalars['CalendarDate']['output']>;
  status: BillStatus;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Source of bill data */
export enum BillSource {
  Assistant = 'ASSISTANT',
  BankFeed = 'BANK_FEED',
  Email = 'EMAIL',
  Sms = 'SMS',
  User = 'USER'
}

/** Status of a bill */
export enum BillStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export type BillSubmission = INode & {
  __typename?: 'BillSubmission';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  bill?: Maybe<Bill>;
  createdAt: Scalars['DateTimeISO']['output'];
  currencyCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate?: Maybe<Scalars['CalendarDate']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutopay?: Maybe<Scalars['Boolean']['output']>;
  lateFeeAmount?: Maybe<Scalars['String']['output']>;
  lateFeeDate?: Maybe<Scalars['CalendarDate']['output']>;
  minAmountDue?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  previousAccountBalance?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerPhone?: Maybe<Scalars['String']['output']>;
  rawAmountDue?: Maybe<Scalars['String']['output']>;
  rawDueDate?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  rawLateFeeAmount?: Maybe<Scalars['String']['output']>;
  rawLateFeeDate?: Maybe<Scalars['String']['output']>;
  rawMinAmountDue?: Maybe<Scalars['String']['output']>;
  rawPreviousAccountBalance?: Maybe<Scalars['String']['output']>;
  rawServiceEndDate?: Maybe<Scalars['String']['output']>;
  rawServiceStartDate?: Maybe<Scalars['String']['output']>;
  rawStatementDate?: Maybe<Scalars['String']['output']>;
  senderIdentifier?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['CalendarDate']['output']>;
  serviceStartDate?: Maybe<Scalars['CalendarDate']['output']>;
  source: BillSubmissionSource;
  statementDate?: Maybe<Scalars['CalendarDate']['output']>;
  status: BillSubmissionStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Source of a bill submission */
export enum BillSubmissionSource {
  Assistant = 'ASSISTANT',
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Status of a bill submission */
export enum BillSubmissionStatus {
  Converted = 'CONVERTED',
  NeedsReview = 'NEEDS_REVIEW',
  Rejected = 'REJECTED'
}

/** How a caregiver is related to a loved one */
export enum CaregiverRelationship {
  Aunt = 'AUNT',
  Father = 'FATHER',
  Grandfather = 'GRANDFATHER',
  Grandmother = 'GRANDMOTHER',
  Mother = 'MOTHER',
  Other = 'OTHER',
  Uncle = 'UNCLE'
}

/** Section of the release draft body whose `- [ ]` items are mutable via the checklist toggle. */
export enum ChecklistSection {
  Prerequisite = 'prerequisite',
  TestPlan = 'testPlan'
}

export type CreateFeatureGateInput = {
  audience?: InputMaybe<FeatureGateAudience>;
  defaultWhenError?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ruleTree: Scalars['JSONObject']['input'];
};

export type DeleteReleaseDraftResult = {
  __typename?: 'DeleteReleaseDraftResult';
  deletedTag: Scalars['String']['output'];
};

export type Document = INode & {
  __typename?: 'Document';
  assetUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  emailMetadata?: Maybe<DocumentEmailMetadata>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type DocumentEmailMetadata = {
  __typename?: 'DocumentEmailMetadata';
  originalFrom?: Maybe<Scalars['String']['output']>;
  originalSubject?: Maybe<Scalars['String']['output']>;
  originalTo?: Maybe<Scalars['String']['output']>;
};

export type Family = INode & {
  __typename?: 'Family';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A member's standing in their household */
export enum FamilyRole {
  Caregiver = 'CAREGIVER',
  Dependent = 'DEPENDENT'
}

export type FeatureGate = {
  __typename?: 'FeatureGate';
  audience: FeatureGateAudience;
  createdAt: Scalars['DateTimeISO']['output'];
  defaultWhenError: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedByUserEmail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ruleTree: Scalars['JSONObject']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Which surfaces a feature gate is exposed to. Server callers evaluate gates of every audience; the audience only constrains the client-bootstrap projection. */
export enum FeatureGateAudience {
  AllClients = 'ALL_CLIENTS',
  MopsWebClient = 'MOPS_WEB_CLIENT',
  ServerOnly = 'SERVER_ONLY',
  WebClient = 'WEB_CLIENT'
}

export type FinancialAccount = IEntity & INode & {
  __typename?: 'FinancialAccount';
  id: Scalars['ID']['output'];
  ignoredAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** @deprecated This field will be removed in a future version */
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subtype?: Maybe<FinancialAccountSubtype>;
  type: FinancialAccountPrimaryType;
};

export enum FinancialAccountPrimaryType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  Payroll = 'PAYROLL'
}

export enum FinancialAccountSubtype {
  Auto = 'AUTO',
  Brokerage = 'BROKERAGE',
  Business = 'BUSINESS',
  CashIsa = 'CASH_ISA',
  CashManagement = 'CASH_MANAGEMENT',
  Cd = 'CD',
  Checking = 'CHECKING',
  Commercial = 'COMMERCIAL',
  Construction = 'CONSTRUCTION',
  Consumer = 'CONSUMER',
  CreditCard = 'CREDIT_CARD',
  CryptoExchange = 'CRYPTO_EXCHANGE',
  Ebt = 'EBT',
  EducationSavingsAccount = 'EDUCATION_SAVINGS_ACCOUNT',
  FixedAnnuity = 'FIXED_ANNUITY',
  Gic = 'GIC',
  HealthReimbursementArrangement = 'HEALTH_REIMBURSEMENT_ARRANGEMENT',
  HomeEquity = 'HOME_EQUITY',
  Hsa = 'HSA',
  Ira = 'IRA',
  Isa = 'ISA',
  Keogh = 'KEOGH',
  Lif = 'LIF',
  LifeInsurance = 'LIFE_INSURANCE',
  LineOfCredit = 'LINE_OF_CREDIT',
  Lira = 'LIRA',
  Loan = 'LOAN',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  MoneyMarket = 'MONEY_MARKET',
  Mortgage = 'MORTGAGE',
  MutualFund = 'MUTUAL_FUND',
  NonCustodialWallet = 'NON_CUSTODIAL_WALLET',
  NonTaxableBrokerageAccount = 'NON_TAXABLE_BROKERAGE_ACCOUNT',
  Other = 'OTHER',
  OtherAnnuity = 'OTHER_ANNUITY',
  OtherInsurance = 'OTHER_INSURANCE',
  Overdraft = 'OVERDRAFT',
  Paypal = 'PAYPAL',
  Payroll = 'PAYROLL',
  Pension = 'PENSION',
  Plan_401A = 'PLAN_401A',
  Plan_401K = 'PLAN_401K',
  Plan_403B = 'PLAN_403B',
  Plan_457B = 'PLAN_457B',
  Plan_529 = 'PLAN_529',
  Prepaid = 'PREPAID',
  Prif = 'PRIF',
  ProfitSharingPlan = 'PROFIT_SHARING_PLAN',
  Qshr = 'QSHR',
  Rdsp = 'RDSP',
  Resp = 'RESP',
  Retirement = 'RETIREMENT',
  Rlif = 'RLIF',
  Roth = 'ROTH',
  Roth_401K = 'ROTH_401K',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  Sarsep = 'SARSEP',
  Savings = 'SAVINGS',
  SepIra = 'SEP_IRA',
  SimpleIra = 'SIMPLE_IRA',
  Sipp = 'SIPP',
  StockPlan = 'STOCK_PLAN',
  Student = 'STUDENT',
  Tfsa = 'TFSA',
  ThriftSavingsPlan = 'THRIFT_SAVINGS_PLAN',
  Trust = 'TRUST',
  Ugma = 'UGMA',
  Utma = 'UTMA',
  VariableAnnuity = 'VARIABLE_ANNUITY'
}

/** How a residence is held */
export enum HousingOwnership {
  Mortgage = 'MORTGAGE',
  Other = 'OTHER',
  OwnOutright = 'OWN_OUTRIGHT',
  Rent = 'RENT'
}

export type IEntity = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type INode = {
  id: Scalars['ID']['output'];
};

export type IProcessorStatusGqlConnection = {
  edges: Array<ProcessorStatusEdge>;
  pageInfo: PageInfo;
};

export type IProcessorStatusGqlEdge = {
  cursor: Scalars['String']['output'];
  node: ProcessorStatusGql;
};

/** Outcome of the bank-account owner-name check run at account selection */
export enum IdentityMatchResult {
  Match = 'MATCH',
  Mismatch = 'MISMATCH',
  Unavailable = 'UNAVAILABLE'
}

export type InspectedObject = {
  __typename?: 'InspectedObject';
  data: Scalars['JSONObject']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** How a forced holdings sync ended; every value but SYNCED names the check that stopped it */
export enum InvestmentHoldingsSyncOutcome {
  InstitutionLacksProduct = 'INSTITUTION_LACKS_PRODUCT',
  NotConsented = 'NOT_CONSENTED',
  NoConnection = 'NO_CONNECTION',
  NoInvestmentAccounts = 'NO_INVESTMENT_ACCOUNTS',
  ProductNotReady = 'PRODUCT_NOT_READY',
  ProviderRefused = 'PROVIDER_REFUSED',
  Synced = 'SYNCED'
}

/** Who or what revoked a debit authorization */
export enum MandateRevocationChannel {
  Bank = 'BANK',
  Processor = 'PROCESSOR',
  SelfServe = 'SELF_SERVE',
  Support = 'SUPPORT',
  System = 'SYSTEM'
}

export type Merchant = IEntity & INode & {
  __typename?: 'Merchant';
  id: Scalars['ID']['output'];
  isIncomeSource: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adminAddAssistantFeedbackComment: AssistantFeedbackComment;
  adminAddToAlphaAllowList?: Maybe<AlphaAllowListEntry>;
  adminAnnouncePreRelease: AnnouncePreReleaseResult;
  adminCreateBill: Bill;
  adminCreateFeatureGate: FeatureGate;
  adminCreateStaticAssetUpload: StaticAssetUpload;
  adminDeleteAccount: Scalars['Boolean']['output'];
  adminDeleteAllAssistantMemoryForUser: Scalars['Int']['output'];
  adminDeleteAllAssistantThreadsForUser: Scalars['Int']['output'];
  adminDeleteAssistantFeedbackComment: AssistantFeedbackComment;
  adminDeleteAssistantMemory: Scalars['Boolean']['output'];
  adminDeleteAssistantThread: Scalars['Boolean']['output'];
  adminDeleteBankConnection: Scalars['String']['output'];
  adminDeleteBill: Scalars['String']['output'];
  adminDeleteBillSubmission: Scalars['String']['output'];
  adminDeleteFeatureGate: Scalars['Boolean']['output'];
  adminDeleteReleaseDraft: DeleteReleaseDraftResult;
  adminDeleteStaticAsset: Scalars['Boolean']['output'];
  adminImpersonateUser: AdminImpersonateUserOutput;
  adminPublishReleaseDraft: Release;
  adminReExtractAssistantThreadMemory: Scalars['Boolean']['output'];
  adminReSyncFinancialData: BankConnection;
  adminRecompactAssistantThread: Scalars['Boolean']['output'];
  adminRemoveFromAlphaAllowList: Scalars['Boolean']['output'];
  adminReopenAssistantFeedback: AssistantFeedback;
  adminResolveAssistantFeedback: AssistantFeedback;
  adminSetFinancialAccountIgnored: FinancialAccount;
  adminStartAssistantBenchmark: AssistantBenchmarkRun;
  adminStartReleasePreview: ReleasePreviewState;
  adminSyncInvestmentHoldings: AdminInvestmentHoldingsSyncResult;
  adminToggleFeatureGate: FeatureGate;
  adminToggleReleaseChecklistItem: ReleaseDraft;
  adminUpdateFeatureGate: FeatureGate;
  adminUpdateProcessorStatus: ProcessorStatusGql;
};


export type MutationAdminAddAssistantFeedbackCommentArgs = {
  body: Scalars['String']['input'];
  feedbackId: Scalars['ID']['input'];
};


export type MutationAdminAddToAlphaAllowListArgs = {
  email: Scalars['String']['input'];
};


export type MutationAdminAnnouncePreReleaseArgs = {
  expectedHeadSha: Scalars['String']['input'];
};


export type MutationAdminCreateBillArgs = {
  input: AdminCreateBillInput;
};


export type MutationAdminCreateFeatureGateArgs = {
  input: CreateFeatureGateInput;
};


export type MutationAdminCreateStaticAssetUploadArgs = {
  contentType: Scalars['String']['input'];
  key: Scalars['String']['input'];
};


export type MutationAdminDeleteAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteAllAssistantMemoryForUserArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteAllAssistantThreadsForUserArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteAssistantFeedbackCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteAssistantMemoryArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  scope: AssistantMemoryScope;
};


export type MutationAdminDeleteAssistantThreadArgs = {
  reason: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
};


export type MutationAdminDeleteBankConnectionArgs = {
  bankConnectionId: Scalars['ID']['input'];
};


export type MutationAdminDeleteBillArgs = {
  billId: Scalars['ID']['input'];
};


export type MutationAdminDeleteBillSubmissionArgs = {
  billSubmissionId: Scalars['ID']['input'];
};


export type MutationAdminDeleteFeatureGateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteReleaseDraftArgs = {
  expectedDraftTag: Scalars['String']['input'];
};


export type MutationAdminDeleteStaticAssetArgs = {
  key: Scalars['String']['input'];
};


export type MutationAdminImpersonateUserArgs = {
  input: AdminImpersonateUserInput;
};


export type MutationAdminPublishReleaseDraftArgs = {
  expectedDraftTag: Scalars['String']['input'];
};


export type MutationAdminReExtractAssistantThreadMemoryArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationAdminReSyncFinancialDataArgs = {
  bankConnectionId: Scalars['ID']['input'];
  resetCursor?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminRecompactAssistantThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationAdminRemoveFromAlphaAllowListArgs = {
  normalizedEmail: Scalars['String']['input'];
};


export type MutationAdminReopenAssistantFeedbackArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationAdminResolveAssistantFeedbackArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationAdminSetFinancialAccountIgnoredArgs = {
  financialAccountId: Scalars['ID']['input'];
  ignored: Scalars['Boolean']['input'];
};


export type MutationAdminStartAssistantBenchmarkArgs = {
  input: AdminStartAssistantBenchmarkInput;
};


export type MutationAdminStartReleasePreviewArgs = {
  headSha?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSyncInvestmentHoldingsArgs = {
  bankConnectionId: Scalars['ID']['input'];
};


export type MutationAdminToggleFeatureGateArgs = {
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationAdminToggleReleaseChecklistItemArgs = {
  checked: Scalars['Boolean']['input'];
  expectedDraftTag: Scalars['String']['input'];
  expectedLineHash: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  section: ChecklistSection;
};


export type MutationAdminUpdateFeatureGateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFeatureGateInput;
};


export type MutationAdminUpdateProcessorStatusArgs = {
  processorStatusId: Scalars['ID']['input'];
  status: ProcessorStatus;
};

export type ObjectInspectorResult = {
  __typename?: 'ObjectInspectorResult';
  alternateMatches: Array<InspectedObject>;
  primary: InspectedObject;
  related: Array<RelatedObjectGroup>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD'
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: PaginationDirection;
  limit: Scalars['Int']['input'];
};

/** How two loved ones in one household are partnered */
export enum PartnerRelationship {
  Divorced = 'DIVORCED',
  DomesticPartner = 'DOMESTIC_PARTNER',
  Other = 'OTHER',
  Spouse = 'SPOUSE'
}

/** A saved payment method's standing */
export enum PaymentMethodStatus {
  Active = 'ACTIVE',
  Detached = 'DETACHED',
  Errored = 'ERRORED',
  VerificationPending = 'VERIFICATION_PENDING'
}

/** The rail a saved payment method charges through */
export enum PaymentMethodType {
  Card = 'CARD',
  UsBankAccount = 'US_BANK_ACCOUNT'
}

/** Status of a processor execution */
export enum ProcessorStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedResolved = 'FAILED_RESOLVED',
  Running = 'RUNNING',
  Skipped = 'SKIPPED'
}

export type ProcessorStatusConnection = IProcessorStatusGqlConnection & {
  __typename?: 'ProcessorStatusConnection';
  edges: Array<ProcessorStatusEdge>;
  pageInfo: PageInfo;
};

export type ProcessorStatusEdge = IProcessorStatusGqlEdge & {
  __typename?: 'ProcessorStatusEdge';
  cursor: Scalars['String']['output'];
  node: ProcessorStatusGql;
};

export type ProcessorStatusFilters = {
  familyId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProcessorStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
  webhookCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorStatusGql = INode & {
  __typename?: 'ProcessorStatusGQL';
  bankConnection?: Maybe<BankConnection>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalBankConnectionId: Scalars['String']['output'];
  familyId?: Maybe<Scalars['ID']['output']>;
  finishTime?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  startTime: Scalars['DateTimeISO']['output'];
  status: ProcessorStatus;
  user?: Maybe<User>;
  webhookCode: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminCurrentUser: User;
  adminEnabledFeatureGates: Array<Scalars['String']['output']>;
  adminGetAllWebhookCodes: Array<Scalars['String']['output']>;
  adminGetAssistantBenchmark?: Maybe<AssistantBenchmarkRun>;
  adminGetAssistantBenchmarkForHead?: Maybe<AssistantBenchmarkRun>;
  adminGetAssistantMemoryForUser: AssistantMemoryListing;
  adminGetAssistantThreadDetail: AssistantThreadDetail;
  adminGetAssistantTurnTranscript: Array<AssistantThreadMessage>;
  adminGetBankConnectionsHealth: Array<BankConnectionHealthStatus>;
  adminGetCurrentReleaseDraft?: Maybe<ReleaseDraft>;
  adminGetDocument: Document;
  adminGetFamilyAccount?: Maybe<AdminFamilyAccount>;
  adminGetFamilyBankConnections: Array<BankConnection>;
  adminGetFeatureGate?: Maybe<FeatureGate>;
  adminGetFeatureGateByName?: Maybe<FeatureGate>;
  adminGetFinancialAccountDetails: Array<AdminFinancialAccountDetail>;
  adminGetInvestmentHoldingsAudit: Array<AdminInvestmentAccountAudit>;
  adminGetProcessorStatuses: ProcessorStatusConnection;
  adminGetRecentAlphaAllowListEntries: Array<AlphaAllowListEntry>;
  adminGetReleaseChangeLog: ReleaseChangeLog;
  adminGetReleasePreview: ReleasePreviewState;
  adminInspectObject?: Maybe<ObjectInspectorResult>;
  adminListAssistantBenchmarks: Array<AssistantBenchmarkRun>;
  adminListAssistantFeedbackComments: Array<AssistantFeedbackComment>;
  adminListAssistantFeedbackForThread: Array<AssistantFeedback>;
  adminListAssistantMemoryJournal: AssistantMemoryJournalListing;
  adminListBillSubmissions: Array<BillSubmission>;
  adminListBills: Array<Bill>;
  adminListFeatureGates: Array<FeatureGate>;
  adminListMerchants: Array<Merchant>;
  adminListRecentAssistantFeedback: AssistantFeedbackListing;
  adminListRecentAssistantThreads: AssistantThreadListing;
  adminListRecurringTransactions: Array<RecurringTransaction>;
  adminListReleases: Array<Release>;
  adminListStaticAssets: Array<StaticAsset>;
  adminListUsers: Array<User>;
  adminListWorkItemJournalEntries: AdminWorkItemJournalEntryListing;
  adminListWorkItemSchedules: AdminWorkItemScheduleListing;
  adminListWorkItems: AdminWorkItemListing;
  adminSearchAccounts: Array<AdminAccountSearchResult>;
  adminSearchAlphaAllowList: Array<AlphaAllowListEntry>;
  health: Scalars['String']['output'];
};


export type QueryAdminGetAssistantBenchmarkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminGetAssistantBenchmarkForHeadArgs = {
  headSha: Scalars['String']['input'];
};


export type QueryAdminGetAssistantMemoryForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminGetAssistantThreadDetailArgs = {
  afterSequence?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['ID']['input'];
};


export type QueryAdminGetAssistantTurnTranscriptArgs = {
  threadId: Scalars['ID']['input'];
  turnId: Scalars['ID']['input'];
};


export type QueryAdminGetBankConnectionsHealthArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminGetDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryAdminGetFamilyAccountArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminGetFamilyBankConnectionsArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminGetFeatureGateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminGetFeatureGateByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryAdminGetFinancialAccountDetailsArgs = {
  familyId: Scalars['ID']['input'];
  financialAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminGetInvestmentHoldingsAuditArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminGetProcessorStatusesArgs = {
  filters?: InputMaybe<ProcessorStatusFilters>;
  pagination: PaginationInput;
};


export type QueryAdminGetReleasePreviewArgs = {
  baseSha: Scalars['String']['input'];
  headSha: Scalars['String']['input'];
};


export type QueryAdminInspectObjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdminListAssistantFeedbackCommentsArgs = {
  feedbackId: Scalars['ID']['input'];
};


export type QueryAdminListAssistantFeedbackForThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type QueryAdminListAssistantMemoryJournalArgs = {
  memoryId?: InputMaybe<Scalars['ID']['input']>;
  sourceThreadId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryAdminListBillSubmissionsArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminListBillsArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminListMerchantsArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminListRecentAssistantFeedbackArgs = {
  before?: InputMaybe<Scalars['DateTimeISO']['input']>;
  familyId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<AssistantFeedbackStatus>;
};


export type QueryAdminListRecentAssistantThreadsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminListRecurringTransactionsArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryAdminListWorkItemJournalEntriesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['ID']['input'];
};


export type QueryAdminListWorkItemSchedulesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  familyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminListWorkItemsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignee?: InputMaybe<AdminWorkItemAssigneeFilter>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  dueNow?: InputMaybe<Scalars['Boolean']['input']>;
  dueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  familyId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<AdminSortDirection>;
  sortField?: InputMaybe<AdminWorkItemSortField>;
  workItemScheduleId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminSearchAccountsArgs = {
  query: Scalars['String']['input'];
};


export type QueryAdminSearchAlphaAllowListArgs = {
  query: Scalars['String']['input'];
};

export type RecurringTransaction = INode & {
  __typename?: 'RecurringTransaction';
  amountRange: Array<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  firstOccurrence: Scalars['CalendarDate']['output'];
  frequency: RecurringTransactionFrequency;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  latestOccurrence: Scalars['CalendarDate']['output'];
  nextOccurrence?: Maybe<Scalars['CalendarDate']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  type: RecurringTransactionType;
};

export enum RecurringTransactionFrequency {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  SemiMonthly = 'SEMI_MONTHLY',
  Unknown = 'UNKNOWN',
  Weekly = 'WEEKLY'
}

export enum RecurringTransactionType {
  Bill = 'BILL',
  Income = 'INCOME',
  Subscription = 'SUBSCRIPTION'
}

export type RelatedObjectGroup = {
  __typename?: 'RelatedObjectGroup';
  count: Scalars['Int']['output'];
  objects: Array<InspectedObject>;
  type: Scalars['String']['output'];
};

export type Release = {
  __typename?: 'Release';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  githubAuthorLogin?: Maybe<Scalars['String']['output']>;
  mopsAuthorEmail?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
  tag: Scalars['ID']['output'];
};

export type ReleaseChangeLog = {
  __typename?: 'ReleaseChangeLog';
  baseSha: Scalars['String']['output'];
  baseTag: Scalars['String']['output'];
  ciStatus: ReleaseCiStatus;
  commits: Array<ReleaseCommit>;
  computedNextTag: Scalars['String']['output'];
  headSha: Scalars['String']['output'];
  releasableHeadSha?: Maybe<Scalars['String']['output']>;
};

export type ReleaseCiStatus = {
  __typename?: 'ReleaseCiStatus';
  cancelledCount: Scalars['Float']['output'];
  conclusion: Scalars['String']['output'];
  failureCount: Scalars['Float']['output'];
  pendingCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type ReleaseCommit = {
  __typename?: 'ReleaseCommit';
  author?: Maybe<Scalars['String']['output']>;
  authoredAt: Scalars['DateTimeISO']['output'];
  body?: Maybe<Scalars['String']['output']>;
  ciConclusion: Scalars['String']['output'];
  prNumber?: Maybe<Scalars['Float']['output']>;
  prUrl?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
  shortSha: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type ReleaseDraft = {
  __typename?: 'ReleaseDraft';
  body: Scalars['String']['output'];
  draftedAt: Scalars['DateTimeISO']['output'];
  draftedByEmail: Scalars['String']['output'];
  htmlUrl: Scalars['String']['output'];
  prerequisiteCheckedIndices: Array<Scalars['Int']['output']>;
  prerequisiteCheckedMarkers: Array<Scalars['String']['output']>;
  prerequisiteLineContents: Array<Scalars['String']['output']>;
  tag: Scalars['ID']['output'];
  targetSha: Scalars['String']['output'];
  testPlanCheckedIndices: Array<Scalars['Int']['output']>;
  testPlanCheckedMarkers: Array<Scalars['String']['output']>;
  testPlanLineContents: Array<Scalars['String']['output']>;
};

export type ReleasePrerequisite = {
  __typename?: 'ReleasePrerequisite';
  prNumbers: Array<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
};

export type ReleasePreview = {
  __typename?: 'ReleasePreview';
  baseSha: Scalars['String']['output'];
  baseTag: Scalars['String']['output'];
  ciStatus: ReleaseCiStatus;
  commits: Array<ReleaseCommit>;
  computedNextTag: Scalars['String']['output'];
  expectedHeadSha: Scalars['String']['output'];
  headSha: Scalars['String']['output'];
  prerequisites: Array<ReleasePrerequisite>;
  riskCallouts: Array<Scalars['String']['output']>;
  summary: Array<Scalars['String']['output']>;
  testPlan: Array<ReleaseTestPlanItem>;
};

export type ReleasePreviewState = {
  __typename?: 'ReleasePreviewState';
  baseSha: Scalars['String']['output'];
  headSha: Scalars['String']['output'];
  preview?: Maybe<ReleasePreview>;
  status: ReleasePreviewStatus;
};

/** Whether the release-notes LLM output is ready (COMPLETED) or still generating (PENDING). */
export enum ReleasePreviewStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type ReleaseTestPlanItem = {
  __typename?: 'ReleaseTestPlanItem';
  action: Scalars['String']['output'];
  expectedResult: Scalars['String']['output'];
};

/** What kind of place a residence is */
export enum ResidenceType {
  Apartment = 'APARTMENT',
  AssistedLiving = 'ASSISTED_LIVING',
  Condo = 'CONDO',
  FamilyMember = 'FAMILY_MEMBER',
  FrequentLocation = 'FREQUENT_LOCATION',
  House = 'HOUSE',
  IndependentLiving = 'INDEPENDENT_LIVING',
  NursingHome = 'NURSING_HOME',
  Other = 'OTHER'
}

/** A phone number's standing SMS consent, as the consent register reports it */
export enum SmsConsentState {
  Granted = 'GRANTED',
  None = 'NONE',
  Revoked = 'REVOKED'
}

export type StaticAsset = {
  __typename?: 'StaticAsset';
  key: Scalars['String']['output'];
  lastModifiedAt: Scalars['DateTimeISO']['output'];
  sizeBytes: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type StaticAssetUpload = {
  __typename?: 'StaticAssetUpload';
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Billing interval for the membership */
export enum SubscriptionInterval {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

/** A household subscription's lifecycle state */
export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Incomplete = 'INCOMPLETE',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING'
}

export type Transaction = INode & {
  __typename?: 'Transaction';
  amount: Scalars['String']['output'];
  category: TransactionCategory;
  currencyCode: Scalars['String']['output'];
  date: Scalars['CalendarDate']['output'];
  description: Scalars['String']['output'];
  financialAccount?: Maybe<FinancialAccount>;
  id: Scalars['ID']['output'];
  isPending: Scalars['Boolean']['output'];
  isUnverified: Scalars['Boolean']['output'];
  merchant?: Maybe<Merchant>;
  pairedTransaction?: Maybe<Transaction>;
  rawDescription?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
};

export type TransactionCategory = INode & {
  __typename?: 'TransactionCategory';
  detailedType?: Maybe<TransactionCategoryDetailedType>;
  id: Scalars['ID']['output'];
  type: TransactionCategoryPrimaryType;
};

export enum TransactionCategoryDetailedType {
  BankFeesAtmFees = 'BANK_FEES_ATM_FEES',
  BankFeesForeignTransactionFees = 'BANK_FEES_FOREIGN_TRANSACTION_FEES',
  BankFeesInsufficientFunds = 'BANK_FEES_INSUFFICIENT_FUNDS',
  BankFeesInterestCharge = 'BANK_FEES_INTEREST_CHARGE',
  BankFeesOtherBankFees = 'BANK_FEES_OTHER_BANK_FEES',
  BankFeesOverdraftFees = 'BANK_FEES_OVERDRAFT_FEES',
  EntertainmentCasinosAndGambling = 'ENTERTAINMENT_CASINOS_AND_GAMBLING',
  EntertainmentMusicAndAudio = 'ENTERTAINMENT_MUSIC_AND_AUDIO',
  EntertainmentOtherEntertainment = 'ENTERTAINMENT_OTHER_ENTERTAINMENT',
  EntertainmentSportingEventsAmusementParksAndMuseums = 'ENTERTAINMENT_SPORTING_EVENTS_AMUSEMENT_PARKS_AND_MUSEUMS',
  EntertainmentTvAndMovies = 'ENTERTAINMENT_TV_AND_MOVIES',
  EntertainmentVideoGames = 'ENTERTAINMENT_VIDEO_GAMES',
  FoodAndDrinkBeerWineAndLiquor = 'FOOD_AND_DRINK_BEER_WINE_AND_LIQUOR',
  FoodAndDrinkCoffee = 'FOOD_AND_DRINK_COFFEE',
  FoodAndDrinkFastFood = 'FOOD_AND_DRINK_FAST_FOOD',
  FoodAndDrinkGroceries = 'FOOD_AND_DRINK_GROCERIES',
  FoodAndDrinkOtherFoodAndDrink = 'FOOD_AND_DRINK_OTHER_FOOD_AND_DRINK',
  FoodAndDrinkRestaurant = 'FOOD_AND_DRINK_RESTAURANT',
  FoodAndDrinkVendingMachines = 'FOOD_AND_DRINK_VENDING_MACHINES',
  GeneralMerchandiseBookstoresAndNewsstands = 'GENERAL_MERCHANDISE_BOOKSTORES_AND_NEWSSTANDS',
  GeneralMerchandiseClothingAndAccessories = 'GENERAL_MERCHANDISE_CLOTHING_AND_ACCESSORIES',
  GeneralMerchandiseConvenienceStores = 'GENERAL_MERCHANDISE_CONVENIENCE_STORES',
  GeneralMerchandiseDepartmentStores = 'GENERAL_MERCHANDISE_DEPARTMENT_STORES',
  GeneralMerchandiseDiscountStores = 'GENERAL_MERCHANDISE_DISCOUNT_STORES',
  GeneralMerchandiseElectronics = 'GENERAL_MERCHANDISE_ELECTRONICS',
  GeneralMerchandiseGiftsAndNovelties = 'GENERAL_MERCHANDISE_GIFTS_AND_NOVELTIES',
  GeneralMerchandiseOfficeSupplies = 'GENERAL_MERCHANDISE_OFFICE_SUPPLIES',
  GeneralMerchandiseOnlineMarketplaces = 'GENERAL_MERCHANDISE_ONLINE_MARKETPLACES',
  GeneralMerchandiseOtherGeneralMerchandise = 'GENERAL_MERCHANDISE_OTHER_GENERAL_MERCHANDISE',
  GeneralMerchandisePetSupplies = 'GENERAL_MERCHANDISE_PET_SUPPLIES',
  GeneralMerchandiseSportingGoods = 'GENERAL_MERCHANDISE_SPORTING_GOODS',
  GeneralMerchandiseSuperstores = 'GENERAL_MERCHANDISE_SUPERSTORES',
  GeneralMerchandiseTobaccoAndVape = 'GENERAL_MERCHANDISE_TOBACCO_AND_VAPE',
  GeneralServicesAccountingAndFinancialPlanning = 'GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING',
  GeneralServicesAutomotive = 'GENERAL_SERVICES_AUTOMOTIVE',
  GeneralServicesChildcare = 'GENERAL_SERVICES_CHILDCARE',
  GeneralServicesConsultingAndLegal = 'GENERAL_SERVICES_CONSULTING_AND_LEGAL',
  GeneralServicesEducation = 'GENERAL_SERVICES_EDUCATION',
  GeneralServicesInsurance = 'GENERAL_SERVICES_INSURANCE',
  GeneralServicesOtherGeneralServices = 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
  GeneralServicesPostageAndShipping = 'GENERAL_SERVICES_POSTAGE_AND_SHIPPING',
  GeneralServicesStorage = 'GENERAL_SERVICES_STORAGE',
  GovernmentAndNonProfitDonations = 'GOVERNMENT_AND_NON_PROFIT_DONATIONS',
  GovernmentAndNonProfitGovernmentDepartmentsAndAgencies = 'GOVERNMENT_AND_NON_PROFIT_GOVERNMENT_DEPARTMENTS_AND_AGENCIES',
  GovernmentAndNonProfitOtherGovernmentAndNonProfit = 'GOVERNMENT_AND_NON_PROFIT_OTHER_GOVERNMENT_AND_NON_PROFIT',
  GovernmentAndNonProfitTaxPayment = 'GOVERNMENT_AND_NON_PROFIT_TAX_PAYMENT',
  HomeImprovementFurniture = 'HOME_IMPROVEMENT_FURNITURE',
  HomeImprovementHardware = 'HOME_IMPROVEMENT_HARDWARE',
  HomeImprovementOtherHomeImprovement = 'HOME_IMPROVEMENT_OTHER_HOME_IMPROVEMENT',
  HomeImprovementRepairAndMaintenance = 'HOME_IMPROVEMENT_REPAIR_AND_MAINTENANCE',
  HomeImprovementSecurity = 'HOME_IMPROVEMENT_SECURITY',
  IncomeDividends = 'INCOME_DIVIDENDS',
  IncomeInterestEarned = 'INCOME_INTEREST_EARNED',
  IncomeOtherIncome = 'INCOME_OTHER_INCOME',
  IncomeRetirementPension = 'INCOME_RETIREMENT_PENSION',
  IncomeTaxRefund = 'INCOME_TAX_REFUND',
  IncomeUnemployment = 'INCOME_UNEMPLOYMENT',
  IncomeWages = 'INCOME_WAGES',
  LoanPaymentsCarPayment = 'LOAN_PAYMENTS_CAR_PAYMENT',
  LoanPaymentsCreditCardPayment = 'LOAN_PAYMENTS_CREDIT_CARD_PAYMENT',
  LoanPaymentsMortgagePayment = 'LOAN_PAYMENTS_MORTGAGE_PAYMENT',
  LoanPaymentsOtherPayment = 'LOAN_PAYMENTS_OTHER_PAYMENT',
  LoanPaymentsPersonalLoanPayment = 'LOAN_PAYMENTS_PERSONAL_LOAN_PAYMENT',
  LoanPaymentsStudentLoanPayment = 'LOAN_PAYMENTS_STUDENT_LOAN_PAYMENT',
  MedicalDentalCare = 'MEDICAL_DENTAL_CARE',
  MedicalEyeCare = 'MEDICAL_EYE_CARE',
  MedicalNursingCare = 'MEDICAL_NURSING_CARE',
  MedicalOtherMedical = 'MEDICAL_OTHER_MEDICAL',
  MedicalPharmaciesAndSupplements = 'MEDICAL_PHARMACIES_AND_SUPPLEMENTS',
  MedicalPrimaryCare = 'MEDICAL_PRIMARY_CARE',
  MedicalVeterinaryServices = 'MEDICAL_VETERINARY_SERVICES',
  Other = 'OTHER',
  PersonalCareGymsAndFitnessCenters = 'PERSONAL_CARE_GYMS_AND_FITNESS_CENTERS',
  PersonalCareHairAndBeauty = 'PERSONAL_CARE_HAIR_AND_BEAUTY',
  PersonalCareLaundryAndDryCleaning = 'PERSONAL_CARE_LAUNDRY_AND_DRY_CLEANING',
  PersonalCareOtherPersonalCare = 'PERSONAL_CARE_OTHER_PERSONAL_CARE',
  RentAndUtilitiesGasAndElectricity = 'RENT_AND_UTILITIES_GAS_AND_ELECTRICITY',
  RentAndUtilitiesInternetAndCable = 'RENT_AND_UTILITIES_INTERNET_AND_CABLE',
  RentAndUtilitiesOtherUtilities = 'RENT_AND_UTILITIES_OTHER_UTILITIES',
  RentAndUtilitiesRent = 'RENT_AND_UTILITIES_RENT',
  RentAndUtilitiesSewageAndWasteManagement = 'RENT_AND_UTILITIES_SEWAGE_AND_WASTE_MANAGEMENT',
  RentAndUtilitiesTelephone = 'RENT_AND_UTILITIES_TELEPHONE',
  RentAndUtilitiesWater = 'RENT_AND_UTILITIES_WATER',
  TransferInAccountTransfer = 'TRANSFER_IN_ACCOUNT_TRANSFER',
  TransferInCashAdvancesAndLoans = 'TRANSFER_IN_CASH_ADVANCES_AND_LOANS',
  TransferInDeposit = 'TRANSFER_IN_DEPOSIT',
  TransferInInvestmentAndRetirementFunds = 'TRANSFER_IN_INVESTMENT_AND_RETIREMENT_FUNDS',
  TransferInOtherTransferIn = 'TRANSFER_IN_OTHER_TRANSFER_IN',
  TransferInSavings = 'TRANSFER_IN_SAVINGS',
  TransferOutAccountTransfer = 'TRANSFER_OUT_ACCOUNT_TRANSFER',
  TransferOutInvestmentAndRetirementFunds = 'TRANSFER_OUT_INVESTMENT_AND_RETIREMENT_FUNDS',
  TransferOutOtherTransferOut = 'TRANSFER_OUT_OTHER_TRANSFER_OUT',
  TransferOutSavings = 'TRANSFER_OUT_SAVINGS',
  TransferOutWithdrawal = 'TRANSFER_OUT_WITHDRAWAL',
  TransportationBikesAndScooters = 'TRANSPORTATION_BIKES_AND_SCOOTERS',
  TransportationGas = 'TRANSPORTATION_GAS',
  TransportationOtherTransportation = 'TRANSPORTATION_OTHER_TRANSPORTATION',
  TransportationParking = 'TRANSPORTATION_PARKING',
  TransportationPublicTransit = 'TRANSPORTATION_PUBLIC_TRANSIT',
  TransportationTaxisAndRideShares = 'TRANSPORTATION_TAXIS_AND_RIDE_SHARES',
  TransportationTolls = 'TRANSPORTATION_TOLLS',
  TravelFlights = 'TRAVEL_FLIGHTS',
  TravelLodging = 'TRAVEL_LODGING',
  TravelOtherTravel = 'TRAVEL_OTHER_TRAVEL',
  TravelRentalCars = 'TRAVEL_RENTAL_CARS'
}

export enum TransactionCategoryPrimaryType {
  BankFees = 'BANK_FEES',
  Entertainment = 'ENTERTAINMENT',
  FoodAndDrink = 'FOOD_AND_DRINK',
  GeneralMerchandise = 'GENERAL_MERCHANDISE',
  GeneralServices = 'GENERAL_SERVICES',
  GovernmentAndNonProfit = 'GOVERNMENT_AND_NON_PROFIT',
  HomeImprovement = 'HOME_IMPROVEMENT',
  Income = 'INCOME',
  LoanPayments = 'LOAN_PAYMENTS',
  Medical = 'MEDICAL',
  Other = 'OTHER',
  PersonalCare = 'PERSONAL_CARE',
  RentAndUtilities = 'RENT_AND_UTILITIES',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL',
  Unknown = 'UNKNOWN'
}

export type UpdateFeatureGateInput = {
  defaultWhenError?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ruleTree?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type User = IEntity & INode & {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  family: Family;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inferredTimezone?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A user account's lifecycle state */
export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  PendingVerification = 'PENDING_VERIFICATION',
  Suspended = 'SUSPENDED'
}

/** How a vehicle is held */
export enum VehicleOwnership {
  Lease = 'LEASE',
  Loan = 'LOAN',
  Other = 'OTHER',
  OwnOutright = 'OWN_OUTRIGHT'
}

/** Which kind of card a work item renders as */
export enum WorkItemUserCategory {
  Config = 'CONFIG',
  Reminder = 'REMINDER',
  Update = 'UPDATE'
}
